export default __webpack_public_path__ + "static/media/Emblem of Dragon's Scales.7c7ef912.jpg";